import type { ValueOf } from 'type-fest'

export const docuSignThemeName = {
  olive: 'Olive',
  ink: 'Ink',
} as const

export type DocuSignThemeId = keyof typeof docuSignThemeName
export type DocuSignThemeName = ValueOf<typeof docuSignThemeName>
